import React, { useMemo } from "react";
import { theme as antdTheme, Typography } from "antd";
import { convertToSignedUrl } from "../utils/wasabiHelper";

/**
 * InlineVideoEmbed — native `<video>` player for a custom-page step's media
 * doc. Receives `media` directly (preferred — parent has step.media[] cached)
 * or just `mediaId` + `mediaResolver(mediaId)`.
 *
 * The URL from BE is canonical (unsigned). Wasabi bucket is private → sign
 * here just like LiveModel3DPreview does for glb URLs. Memoize so the src
 * stays stable across re-renders (otherwise `<video>` reloads).
 */
const InlineVideoEmbed = ({ media, mediaId, mediaResolver }) => {
  const { token } = antdTheme.useToken();
  const resolved = media || (mediaResolver ? mediaResolver(mediaId) : null);

  const src = useMemo(() => {
    if (!resolved?.url) return null;
    if (typeof resolved.url === "string" && resolved.url.includes("wasabisys.com")) {
      return convertToSignedUrl(resolved.url) || resolved.url;
    }
    return resolved.url;
  }, [resolved?.url]);

  if (!src) {
    return (
      <div
        style={{
          margin: "14px 0",
          padding: 12,
          borderRadius: 8,
          border: `1px dashed ${token.colorBorderSecondary}`,
          color: token.colorTextTertiary,
        }}
      >
        <Typography.Text type="secondary">
          Video unavailable (mediaId: {mediaId})
        </Typography.Text>
      </div>
    );
  }

  return (
    <div
      style={{
        margin: "16px 0",
        borderRadius: 10,
        overflow: "hidden",
        boxShadow: `0 2px 8px ${token.colorFillTertiary}`,
      }}
    >
      <video
        src={src}
        controls
        poster={resolved?.poster}
        style={{ display: "block", width: "100%", maxHeight: 520, background: "#000" }}
      />
    </div>
  );
};

export default InlineVideoEmbed;
